// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__VVlpM","resendInfoText":"OnGoingPaymentBox_resendInfoText__3qUAG"};